class FdHeaderSearch extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    this.input = this.querySelector('input[name="q"]');

    this.onRootClick = this.onRootClick.bind(this);
    this.onDocClick = this.onDocClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.addEventListener("click", this.onRootClick);
    document.addEventListener("click", this.onDocClick);
    window.addEventListener("keydown", this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onDocClick);
    window.removeEventListener("keydown", this.onKeydown);
  }

  get isOpen() {
    return this.classList.contains("fd-header-search--open");
  }

  onRootClick(event) {
    if (event.target.closest(".js-fd-header-search-open")) {
      this.open();
    } else if (event.target.closest(".js-fd-header-search-close")) {
      this.close();
    } else if (event.target.closest(".fd-header-search__input .fd-input__icon--right")) {
      event.preventDefault();
      this.submitSearch();
    }
  }

  onDocClick(event) {
    // Close when clicking anywhere outside the open field (replaces @click.outside).
    if (this.isOpen && !this.contains(event.target)) this.close();
  }

  onKeydown(event) {
    if (event.key === "Escape" && this.isOpen) this.close();
  }

  open() {
    this.classList.add("fd-header-search--open");
    if (this.form) this.form.inert = false;
    if (this.input) this.input.focus();
  }

  close() {
    this.classList.remove("fd-header-search--open");
    if (this.form) this.form.inert = true;
  }

  submitSearch() {
    if (!this.form) return;

    if (typeof this.form.requestSubmit === "function") {
      this.form.requestSubmit();
    } else {
      this.form.submit();
    }
  }
}

customElements.define("fd-header-search", FdHeaderSearch);
